var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_922_577",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L8.66667 13L17.3333 0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_922_577)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 0C1.51675 0 -4.33325 5.85 -4.33325 13C-4.33325 20.15 1.51675 26 8.66675 26C15.8167 26 21.6667 20.15 21.6667 13C21.6667 5.85 15.8167 0 8.66675 0ZM8.66683 22.75C3.25016 22.75 -1.08317 18.4167 -1.08317 13C-1.08317 7.58334 3.25016 3.25001 8.66683 3.25001C14.0835 3.25001 18.4168 7.58334 18.4168 13C18.4168 18.4167 14.0835 22.75 8.66683 22.75Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 3.25C3.25008 3.25 -1.08325 7.58333 -1.08325 13C-1.08325 18.4167 3.25008 22.75 8.66675 22.75C14.0834 22.75 18.4167 18.4167 18.4167 13C18.4167 7.58333 14.0834 3.25 8.66675 3.25ZM8.66675 19.5C5.09175 19.5 2.16675 16.575 2.16675 13C2.16675 9.42501 5.09175 6.50001 8.66675 6.50001C12.2417 6.50001 15.1667 9.42501 15.1667 13C15.1667 16.575 12.2417 19.5 8.66675 19.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 6.5C5.09175 6.5 2.16675 9.425 2.16675 13C2.16675 16.575 5.09175 19.5 8.66675 19.5C12.2417 19.5 15.1667 16.575 15.1667 13C15.1667 9.425 12.2417 6.5 8.66675 6.5ZM8.66679 16.25C6.82513 16.25 5.41679 14.8417 5.41679 13C5.41679 11.1583 6.82513 9.75001 8.66679 9.75001C10.5085 9.75001 11.9168 11.1583 11.9168 13C11.9168 14.8417 10.5085 16.25 8.66679 16.25Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 16.25C10.4617 16.25 11.9167 14.7949 11.9167 13C11.9167 11.2051 10.4617 9.75 8.66675 9.75C6.87182 9.75 5.41675 11.2051 5.41675 13C5.41675 14.7949 6.87182 16.25 8.66675 16.25Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.38d66acde5a95e1b820df81b78d785f6.svg";
export { ForwardRef as ReactComponent };